;(function() {
/* @ngInject */
function ContactBoxesController() {
    let vm = this;

    vm.map = {
        ba: {
            map: "48.141199,17.1252475",
            marker: "48.1412149,17.1272336"
        },
        ke: {
            map: "48.7067992,21.2654854",
            marker: "48.693370757161844,21.274335854540286"
        }
    }
}

angular.module("firmaren")
    .component("contactBoxes", {
        templateUrl: "/app/shared/contact-boxes/contact-boxes.html",
        controller: ContactBoxesController,
        controllerAs: "vm",
        bindings: {
            showQuestionButton: "<"
        }
    });
}());
